import axiosClient from './axiosClient';
export default {
  list: (params) => axiosClient.get('/pagamenti', { params }),
  get: (id) => axiosClient.get(`/pagamenti/${id}`),
  payWithCard: (id) => axiosClient.post(`/pagamenti/${id}/pay`),
  create: (data) => axiosClient.post('/pagamenti', data),
  update: (id, data) => axiosClient.put(`/pagamenti/${id}`, data),
  delete: (id) => axiosClient.delete(`/pagamenti/${id}`),
  uploadFile: (id, formData) => axiosClient.post(`/pagamenti/${id}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
  }),
  downloadFile: (id) =>
    axiosClient.get(`/pagamenti/${id}/download`, {
      responseType: 'blob'
    }),
};